/** 平台环境常量 */
const PLATFORM = {
  h5: 'h5',
  hippy: 'hippy',
};

export { PLATFORM };
